import { useTranslation, Trans } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { DOCS_URL, HUB_URL } from '../post-signup-onboarding-constants';

interface ResultMorStepProps {
	onComplete: () => void;
	onPrev?: () => void;
}

/** Step 3 (lt50k path): Register for MoR with partner, link to hub + docs, Continue. */
export function ResultMorStep({ onComplete, onPrev }: ResultMorStepProps) {
	const { t } = useTranslation('onboarding');
	return (
		<div className="space-y-6">
			<div className="space-y-2">
				<h2 className="text-foreground text-2xl font-bold tracking-tight">
					{t('resultMor.title')}
				</h2>
			</div>

			<div className="mx-auto max-w-lg rounded-xl border border-blue-200 bg-blue-50 p-5 text-left dark:border-blue-900 dark:bg-blue-950/20">
				<p className="text-sm leading-relaxed text-blue-800 dark:text-blue-200">
					<Trans
						i18nKey="onboarding:resultMor.description"
						components={{
							1: (
								<a
									href={HUB_URL}
									target="_blank"
									rel="noopener noreferrer"
									className="font-medium text-blue-600 underline underline-offset-2 dark:text-blue-400"
								/>
							),
							2: (
								<a
									href={DOCS_URL}
									target="_blank"
									rel="noopener noreferrer"
									className="font-medium text-blue-600 underline underline-offset-2 dark:text-blue-400"
								/>
							),
						}}
					/>
				</p>
			</div>

			<a
				href={HUB_URL}
				target="_blank"
				rel="noopener noreferrer"
				className="border-primary text-primary hover:bg-primary/5 inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-medium transition-colors"
			>
				{t('resultMor.goToHub')}
				<ExternalLink className="h-4 w-4" />
			</a>

			<div className="mx-auto flex w-full max-w-md gap-3">
				{onPrev && (
					<Button onClick={onPrev} variant="outline" size="lg" className="flex-1">
						{t('back')}
					</Button>
				)}
				<Button onClick={onComplete} size="lg" className="flex-1">
					{t('resultMor.continue')}
				</Button>
			</div>
		</div>
	);
}
